import request from '@/utils/request'

export function fetchList(data) {
  return request({
    url:'/product/list',
    method:'post',
    data:data
  })
}

export function fetchAssociateList(data) {
  return request({
    url:'/product/associate',
    method:'post',
    data:data
  })
}

export function esAdapterImg(data) {
  return request({
    url:'/product/adapter/img',
    method:'post',
    data:data
  })
}

export function savePublishStatus(data) {
  return request({
    url:'/product/batch/add',
    method:'post',
    data:data
  })
}


export function fetchSaleList(data) {
  return request({
    url:'/product/sale/list',
    method:'post',
    data:data
  })
}

export function fetchSimpleList(params) {
  return request({
    url:'/product/simpleList',
    method:'get',
    params:params
  })
}

export function fetchLogList(data) {
  return request({
    url:'/product/get/log',
    method:'post',
    data:data
  })
}

export function updateDeleteStatus(params) {
  return request({
    url:'/product/update/deleteStatus',
    method:'post',
    params:params
  })
}

export function updateNewStatus(params) {
  return request({
    url:'/product/update/newStatus',
    method:'post',
    params:params
  })
}

export function updateRecommendStatus(params) {
  return request({
    url:'/product/update/recommendStatus',
    method:'post',
    params:params
  })
}

export function updatePublishStatus(data) {
  return request({
    url:'/product/batch/edit',
    method:'post',
    data:data
  })
}

export function createProduct(data) {
  return request({
    url:'/product/add',
    method:'post',
    data:data
  })
}

export function updateProduct(data) {
  return request({
    url:'/product/edit/',
    method:'post',
    data:data
  })
}

export function getProduct(data) {
  return request({
    url:'/product/get',
    method:'post',
    data:data
  })
}

export function getProductExt(data) {
  return request({
    url:'/product/get/ext',
    method:'post',
    data:data
  })
}

export function fetchSecurityList(data) {
  return request({
    url:'/product/security',
    method:'post',
    data:data
  })
}

export function securityChange(data) {
  return request({
    url:'/product/security/change',
    method:'post',
    data:data
  })
}

export function securityShelf(data) {
  return request({
    url:'/product/security/shelf',
    method:'post',
    data:data
  })
}

export function allotStock(data) {
  return request({
    url:'/product/stock/allot',
    method:'post',
    data: data
  })
}

export function fetchLikeList(data) {
  return request({
    url:'/product/like/list',
    method:'post',
    data:data
  })
}

export function getProductSecret(data) {
  return request({
    url:'/callback/v1/goods/get/' + data,
    method:'get'
  })
}

export function getProductListSecret(secret, data) {
  return request({
    url:'/web/goods/list/' + secret,
    method:'post',
    data:data
  })
}

export function updateProductListSecret(secret, data) {
  return request({
    url:'/web/goods/update/' + secret,
    method:'post',
    data:data
  })
}

export function delProductListSecret(secret, id) {
  return request({
    url:'/web/goods/del/' + secret +'/' + id,
    method:'get'
  })
}

export function getProductInfoSecret(secret, id) {
  return request({
    url:'/web/goods/info/' + secret +'/' + id,
    method:'get'
  })
}

export function adapterGoogsImgSecret(secret, data) {
  return request({
    url: '/web/goods/adapter/img/' + secret,
    method: 'post',
    data: data
  })
}





// WEBPACK FOOTER //
// ./src/api/product.js